import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import FlexBox from 'components/common/FlexBox';
import TextTableCell from 'components/common/table/TextTableCell';

const ReportItem = ({ data, onDelete }) => {
  const { t } = useTranslation();
  const historyContext = useHistoryWithContext();

  const handleEdit = useCallback(() => {
    historyContext.push(`/reports/${data.reportId}`);
  }, [historyContext, data]);

  return (
    <TableRow hover key={data.reportId}>
      <TextTableCell content={data.reportName} />
      <TableCell>{data.reportFriendlyName}</TableCell>
      <TableCell>
        <FlexBox gap={0.5} justifyContent='end'>
          <IconButton type='edit' size='small' variant='text' color='primary' tooltip={t('Reports.Edit')} onClick={handleEdit} />
          <IconButton
            type='delete'
            size='small'
            variant='text'
            color='primary'
            tooltip={t('Reports.Delete')}
            onClick={() => onDelete(data.reportId)}
          />
        </FlexBox>
      </TableCell>
    </TableRow>
  );
};

ReportItem.propTypes = {
  data: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default ReportItem;
